<template>
  <div id="app">
    <Consent/>
    <Loginform v-if="$root.login" v-bind:otc="$route.query.otc ? $route.query.otc : false" v-on:close="$root.login = false"/>
    <router-view name="content"></router-view>
  </div>
</template>

<style lang="scss">
  @import "main";
</style>

<script>
import Loginform from '@/components/Loginform.vue'
import Consent from '@/components/Consent.vue'

export default {
  name: 'home',
  components: {
        Loginform,
        Consent
  },
  created: function () {
    if (this.$route.name === 'forgot') {
      this.$root.login =  true;
      this.$root.logindata = {}
    }
  },  
}
</script>
